// extracted by mini-css-extract-plugin
export default {"container":"AspectRatio_container__J9Va7","content":"AspectRatio_content__FcO3H"};